import { Lookup } from "devextreme-react";
import { MutableRefObject } from "react";
import { getDesignSearchDataSource } from "@service/design/design-service";

export const DesignEditComponent = (
  props: any,
  dataGridRef: MutableRefObject<any>,
  accessType: string,
  companyId: number,
) => {
  const designSearchExprOption: string[] = ["name", "title", "id", "mobileNumber"];

  const handleValueChanged = (e: any) => {
    const { data } = props;
    data.setValue(e.value);
    dataGridRef.current.instance.saveEditData();
  };

  const itemComponent = ({ data: item }: any) => {
    if (item) {
      if (item.customer) {
        return <div>{`${item.id}, ${item.title}, ${item.customer.name}/${item.customer.mobileNumber}`}</div>;
      } else {
        return <div>{`${item.id}, ${item.title}`}</div>;
      }
    } else {
      return <div></div>;
    }
  };

  return (
    <Lookup
      dataSource={getDesignSearchDataSource(accessType, companyId)}
      itemComponent={itemComponent}
      placeholder="설계번호, 제목, 고객명으로 검색"
      searchExpr={designSearchExprOption}
      searchMode={"contains"}
      value={props.data.value}
      onValueChanged={handleValueChanged}
    />
  );
};
